import { SearchIcon } from '../../assets/icons/search'
import { SaveAnimated } from '../SaveAnimated'
import {
  ButtonOrganizationListStyle,
  ContainerOrganizationListStyle,
  OrganizationListStyle,
  Organization,
  OrganizationStyle,
  ListStyle,
  OrganizationFrame,
  OrganizationFrameActive,
  DivInput,
  InputStyle,
  Span,
  Search,
  SelecioneUmaOrganizacao,
} from './styles'
import { useOrganizationList } from './useOrganizationList'

export function OrganizationList() {
  const {
    filteredOrganizations,
    header,
    setHeader,
    openModal,
    setOpenModal,
    openModal2,
    mensagem,
    searchOrg,
    setSearchOrg,
    orgSelecionada,
    setOrgSelecionada,
  } = useOrganizationList()

  const renderOrganization = (organizacao: any) => {
    const handleClick = () => setHeader(organizacao.tenantId)
    return (
      <OrganizationListStyle key={organizacao.id}>
        {header === organizacao.tenantId ? (
          <OrganizationFrameActive onClick={handleClick}>
            <Organization>{organizacao.nome}</Organization>
          </OrganizationFrameActive>
        ) : (
          <OrganizationFrame onClick={handleClick}>
            <Organization>{organizacao.nome}</Organization>
          </OrganizationFrame>
        )}
      </OrganizationListStyle>
    )
  }

  return (
    <>
      <ContainerOrganizationListStyle>
        <OrganizationStyle>
          <Search>
            <h1>Selecione a organização</h1>
            <DivInput>
              <InputStyle
                value={searchOrg}
                onChange={event => setSearchOrg(event.target.value)}
                placeholder="Pesquise uma organização"
                sizeX="225px"
                sizeY="42px"
              />
              <Span>
                <SearchIcon />
              </Span>
            </DivInput>
          </Search>
          <ListStyle>
            {filteredOrganizations?.map(renderOrganization)}
          </ListStyle>

          <ButtonOrganizationListStyle
            type="button"
            onClick={() =>
              header !== '' ? setOpenModal(!openModal) : setOrgSelecionada(true)
            }
          >
            {mensagem()}
          </ButtonOrganizationListStyle>
          {orgSelecionada ? (
            <SelecioneUmaOrganizacao>
              Selecione uma organização
            </SelecioneUmaOrganizacao>
          ) : (
            ''
          )}
        </OrganizationStyle>
      </ContainerOrganizationListStyle>
      {openModal && <SaveAnimated mensagem="carregando" />}
      {openModal2 && <SaveAnimated mensagem="pronto" />}
    </>
  )
}
